import { UserRoleEnum } from "app/shared/enums";

export class LoggedUserModel  {
  company_id?: number;
  user_email?: string;
  user_name?: string;
  full_name?: string;
  user_role?: UserRoleEnum;
  constructor(company_id?: number, user_email?: string, user_name?: string, full_name?: string, user_role?: UserRoleEnum) {
    this.company_id = company_id;
    this.full_name = full_name;
    this.user_email = user_email;
    this.user_name = user_name;
    this.user_role = user_role;
  }
}

export class AuthResponseModel extends LoggedUserModel {
  access_token = '';
  refresh_token = '';
  has_erp_config = true;
}
